
/** data-test-id used for quickly finding elements on rest jest tests */
export const dataTestId = {
    /** assign job button at the top of the job listing ( below filter control ) */
    jobAssing: "job-assign-offer",
    /** job listing item, usually formated as `job-listing-job-[job.id]`, for instance, `job-listing-job-1235123`*/
    jobList: "job-listing-job-",
    /** assign job button in the job dispatch modal window */
    jobAssingButton: "job-assign-offer-button",
    integration: {
        locations: {
            list: "integration--location-list",
            refresh: "integration--location-fetch"
        },
        new: "integration--add-new",
        select: "integration--select-new",
        init: "integration--init-configuration",
        /** displayed as integration--profile-[platform name] */
        row: "integration--profile-",
        refresh: "integration--refresh",
        iframe: 'integation--tray-iframe'
    },
    general: {
        /** used in PageLoader */
        pageLoading: "page--loading",
        /** used in OverlayablePanel */
        componentLoading: "component--loading",

    }

}